import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const EnventCalander = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 49 49"
      fill="none"
      {...rest}
    >
      <path
        d="M16.8989 4.88599V10.886"
        stroke="#9759CC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8989 4.88599V10.886"
        stroke="#9759CC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.89893 19.0659H41.8989"
        stroke="#9759CC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8989 17.886V34.886C42.8989 40.886 39.8989 44.886 32.8989 44.886H16.8989C9.89893 44.886 6.89893 40.886 6.89893 34.886V17.886C6.89893 11.886 9.89893 7.88599 16.8989 7.88599H32.8989C39.8989 7.88599 42.8989 11.886 42.8989 17.886Z"
        stroke="#9759CC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M24.8899 28.2861H24.9079"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M17.4875 28.2861H17.5055"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M17.4878 34.2861H17.5058"
        stroke="#9759CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

EnventCalander.displayName = 'EnventCalander';
